import { Link } from "react-router-dom";
import { footerNav, legalDisclaimer, lineUrl } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-abyss-800 border-t border-cyber-gold/10">
      <div className="mx-auto px-4 md:px-6 lg:px-8 py-14 md:py-20" style={{ maxWidth: 1280 }}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg border border-cyber-gold/40 bg-abyss-700/60">
                <i className="ri-cpu-line text-cyber-gold text-lg" />
              </div>
              <div className="flex flex-col">
                <span className="text-cyber-gold font-bold text-base tracking-wide">
                  時光逆行駭客
                </span>
                <span className="font-mono text-base text-neon-blue tracking-widest">
                  CHRONOHACKER
                </span>
              </div>
            </Link>
            <p className="text-ghost-dim text-base leading-relaxed mb-6">
              老化，是一段可以被駭入的程式。
              <br />
              曾驛翔院長帶領逆齡科技美學團隊，
              <br />
              為您設計專屬逆齡路線圖。
            </p>
            <div className="flex items-center gap-3">
              <a
                href={lineUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#06C755] flex items-center justify-center text-white hover:scale-110 transition-transform"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-lg" />
              </a>
              <span className="font-mono text-base text-ghost-dim">@404wdnql</span>
            </div>
          </div>

          {/* Nav Links */}
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-ghost font-medium text-base mb-4 tracking-wide">關於品牌</h4>
              <ul className="flex flex-col gap-2.5">
                {footerNav.about.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-ghost-muted text-base hover:text-cyber-gold transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-ghost font-medium text-base mb-4 tracking-wide">服務項目</h4>
              <ul className="flex flex-col gap-2.5">
                {footerNav.services.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-ghost-muted text-base hover:text-cyber-gold transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-ghost font-medium text-base mb-4 tracking-wide">資源中心</h4>
              <ul className="flex flex-col gap-2.5">
                {footerNav.resources.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-ghost-muted text-base hover:text-cyber-gold transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-cyber-gold/10">
        <div className="mx-auto px-4 md:px-6 lg:px-8 py-5" style={{ maxWidth: 1280 }}>
          <div className="flex flex-col gap-4">
            <p className="text-ghost-dim text-base leading-relaxed">{legalDisclaimer}</p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
              <p className="text-ghost-dim text-base">
                &copy; {new Date().getFullYear()} 時光逆行駭客 CHRONOHACKER. All rights reserved.
              </p>
              <p className="text-ghost-dim text-base">
                曾驛翔院長醫學美容團隊
              </p>
            </div>
            <p className="text-ghost-dim/50 text-sm">
              品牌官網建置｜
              <a
                href="https://vpivip.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-cyber-gold/60 transition-colors"
              >
                天地人網整合行銷
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}